import { newsletterFrequencies } from 'shared/constants/news/newsletterFrequencies';
import { emailFrequencies } from 'shared/constants/news/emailFrequencies';
import { newsFeedSettingsParser, newsletterSettingsParser } from 'shared/parsers';

import {
  GET_NEWS_FEED,
  GET_NEWS_FEED_SUCCESS,
  GET_NEWS_FEED_ERROR,
  SAVE_FEED_SETTINGS,
  REQUEST_RATING_NEWS_FINISHED,
  REQUEST_RATING_NEWS,
  GET_PREFERENCES,
  GET_PREFERENCES_FINISHED,
  SAVE_PREFERENCES,
  SAVE_PREFERENCES_FINISHED,
} from './newsFeedActions';

const initialState = {
  data: [],
  total: 0,
  isPending: false,
  isPreferencesPending: false,
  settings: {
    newsFeed: {
      newsTypes: [],
      industryTypes: [],
      countriesList: [],
      limitToFollowedAnalysts: false,
    },
    newsletter: {
      frequency: newsletterFrequencies.NONE,
      newsTypes: [],
      industryTypes: [],
      countriesList: [],
      limitToFollowedAnalysts: false,
      useNewsFeedPreferences: false,
    },
  },
  preferences: {
    emailNotifications: {
      frequency: emailFrequencies.DISABLED,
      type: [],
    },
    newsFeed: {
      classifications: [],
      limitToFollowedAnalysts: false,
      news: [],
    },
    newsletter: {
      classifications: [],
      frequency: newsletterFrequencies.WEEKLY,
      limitToFollowedAnalysts: false,
      news: [],
      useNewsFeedPreferences: false,
    },
    isPending: true,
  },
  shouldRefresh: false,
  ratingRequestError: false,
  defaultPrefsSet: false,
};

export function newsFeed(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case GET_NEWS_FEED:
      return { ...state, isPending: true, ratingRequestError: false, shouldRefresh: false };
    case GET_NEWS_FEED_SUCCESS:
      return {
        ...state,
        isPending: false,
        data: payload.data,
        total: payload.total,
      };
    case GET_NEWS_FEED_ERROR:
      return { ...state, isPending: false };
    case SAVE_FEED_SETTINGS:
      return { ...state, settings: payload.settings, shouldRefresh: true };
    case REQUEST_RATING_NEWS:
      return { ...state, isPending: true, ratingRequestError: false };
    case REQUEST_RATING_NEWS_FINISHED:
      return {
        ...state,
        isPending: false,
        shouldRefresh: !(payload && payload.error),
        ratingRequestError: !!(payload && payload.error),
      };
    case GET_PREFERENCES:
      return { ...state, isPending: true, shouldRefresh: false, defaultPrefsSet: false };
    case GET_PREFERENCES_FINISHED: {
      const preferences = payload.preferences || {};
      return {
        ...state,
        isPending: false,
        preferences: {
          ...preferences,
          isPending: false,
        },
        settings: {
          newsFeed: newsFeedSettingsParser(preferences),
          newsletter: newsletterSettingsParser(preferences),
        },
        defaultPrefsSet: payload.defaultPrefs,
        shouldRefresh: !payload.defaultPrefs,
      };
    }
    case SAVE_PREFERENCES:
      return { ...state, isPreferencesPending: true };
    case SAVE_PREFERENCES_FINISHED:
      return { ...state, isPreferencesPending: false };
    default:
      return state;
  }
}
